
class EventBus{
	events:any
	constructor(){
	    // 一个数组,存放callback的地方,格式为 事件名:回调函数数组
	    this.events = {}
	}
	// 发布
	$emit(eventName:string, ...data:any) {
	     // 通过可选链运算符,跳过判断直接遍历调用
	     this.events[eventName]?.forEach((callback:any) => {
			 callback(...data)
	     })
	}
	// 订阅
	$on(eventName:string, callback?:any) {
	    // 用一个三元简单判断一下有无注册事件,有则push,无则添加
	    //console.log('eventName', eventName);
	    this.events[eventName]?this.events[eventName].push(callback):this.events[eventName] = [callback];
		//console.log('eventName', eventName)
	}
	// 取消订阅
	$off(eventName?:string, callback?:any) {
		if(!eventName){
			this.events={};
		}
	    if (eventName && this.events[eventName]) {
			if(!callback){
				delete this.events[eventName];
			}else{
				for(let i of this.events[eventName]) {
					if(this.events[eventName][i] === callback) {
						delete this.events[eventName][i];
					}
				}
			}
	    }
	}
}
export default new EventBus();